import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import colors from "assets/theme-dark/base/colors";
import { useHeadroomContext } from "../context/HeadRoomProvider";

interface TabSelectorProps {
  isCollapsed: boolean;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  activeTab: number;
}

const TabSelector: React.FC<TabSelectorProps> = ({ isCollapsed, onTabChange, activeTab }) => {
  const { selectedProject } = useHeadroomContext();

  return (
    <StyledCard sx={{ width: "100%", marginTop: isCollapsed ? "1rem" : "0", transition: "margin-top 0.3s ease" }}>
      <StyledTabs value={activeTab} onChange={onTabChange} aria-label="dashboard tabs">
        <StyledTab label="Segmentation" active={activeTab === 0} />
        <StyledTab label="Input for Headroom" active={activeTab === 1} />
        <StyledTab label="Headroom" active={activeTab === 2} />
        <StyledTab disabled={!selectedProject} label="Dashboard" active={activeTab === 3} />
      </StyledTabs>
    </StyledCard>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: "10px",
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    display: "flex",
    width: "100%",
  },
}));

const StyledTab = styled(Tab)<{ active?: boolean }>(({ theme, active }) => ({
  minHeight: "10px",
  height: "10px",
  fontSize: "14px",
  textTransform: "none",
  color: active ? colors.black.main : colors.grey[500],
  backgroundColor: active ? colors.white.main : colors.grey[200],
  flex: 1,
  maxWidth: "none",
  "&:hover": {
    backgroundColor: active ? colors.white.main : colors.grey[300],
  },
  transition: "all 0.3s ease",
}));

const StyledCard = styled(Box)(({ theme }) => ({
  background: `linear-gradient(145deg, ${colors.background.card} 0%, ${colors.background.default} 100%)`,
  borderRadius: theme.spacing(1.5),
  padding: "5px",
  boxShadow: theme.shadows[4],
  transition: "all 0.3s ease",
  width: "100%",
}));

export default TabSelector;
